import { Control, FieldValues, Path, useController } from "react-hook-form";

import { Textarea, TextareaProps } from "#shared/view/designSystem/inputs/Textarea";

interface Props<T extends FieldValues> extends TextareaProps {
  label?: string;
  required?: boolean;
  step?: string;
  rows?: number;
  control: Control<T>;
  name: Path<T>;
}

export const TextareaController = <T extends FieldValues>({
  name,
  label,
  control,
  ...props
}: Props<T>) => {
  const {
    field,
    fieldState: { error },
  } = useController({ name, control });
  return (
    <Textarea
      {...field}
      value={field.value}
      label={label}
      // oxlint-disable-next-line typescript/no-base-to-string
      error={error?.message?.toString() || !!error?.type}
      autosize
      minRows={1}
      maxRows={4}
      {...props}
    />
  );
};
